import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CoreOffcanvasComponent } from '../../../ui-components/core-offcanvas/core-offcanvas.component';
import { AppMessageService } from '../../../shared/services/app-message/app-message.service';
import { Option } from '../../../ui-components/core-dropdown/core-dropdown.component';
import { Calendar } from 'primeng/calendar';
import { InstituationService } from '../services/institiuation.service';
import { AddressAutocompleteComponent } from '../../../ui-components/address-autocomplete/address-autocomplete.component';
import { ParameterService } from '../../../shared/services/parameter/parameter.service';
import { PhoneNumbersComponent } from '../../../shared/components/phone-numbers/phone-numbers.component';
import { ActivatedRoute } from '@angular/router';
import { CaseService } from '../../case/services/case.services';
import { CaseInformation } from '../models/instituation';
import { CaseStatusesEnum } from '../../case/interfaces/interfaces';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { CaseStatusPipe } from '../../../shared/pipes/case-status.pipe';
import { DateFormatPipe } from '../../../shared/pipes/date.pipe';

@Component({
  selector: 'app-create-instituation',
  templateUrl: './create-instituation.component.html',
  styleUrl: './create-instituation.component.scss',
  providers:[CaseStatusPipe, DateFormatPipe]
})
export class CreateInstituationComponent implements OnInit {
  @ViewChild('startCalendar') startCalendar: Calendar;
  @ViewChild('instituationCanvas') canvas: CoreOffcanvasComponent;
  @Output() saveOn = new EventEmitter<any>();
  @Output() updateOn = new EventEmitter<any>();
  @Output() checkSaveConditionOn = new EventEmitter<any>();
  @ViewChild('addressComponent') addressComponent: AddressAutocompleteComponent;
  @Input() instituationList: any[] = [];
  @ViewChild('contactComponent') contactComponent: PhoneNumbersComponent;
  selectedTab: 'instituation' | 'case' = 'instituation'; // Varsayılan sekme

  showCaseCollapse: boolean = false;
  first = 0;
  rows = 10;
  totalCaseRecords: number = 0;
  caseTypes: any[] = [];
  statuses: { label: string; value: CaseStatusesEnum }[] = [];


  caseFilter: {
    caseType: number | null;
    caseStatus: number | null;
    startDate: Date | null;
    endDate: Date | null;
    callInstitution: boolean | null;
    dropoffInstitution: boolean | null;
    pickupInstitution: boolean | null;
  } = {
    caseType: null,
    caseStatus: null,
    startDate: null,
    endDate: null,
    callInstitution: true,
    dropoffInstitution: true,
    pickupInstitution: true,
  };
  caseList: CaseInformation[] = [];
  caseListExcel:[]=[];

  phoneTypes: { label: string; value: number }[] = [];

  form: FormGroup;
  initialForm: any = {
    instituationShortCode: '',
    title: '',
    mainInstituationId: null,
    signboard: '',
    taxOffice: '',
    taxNumber: '',
    contacts: [],
    termDay: '',
    labmedUsername: '',
    labmedInstituationCode: '',
    labmedUserPassword: '',
    isActive: true,
    instituationType: null,
    erpCode: '',
    note: '',
    isMotherChildInstituation: true,
    address: null,
    provisionable: false,
    invoiceable:false,
    isFieldSales:false,
  };
  isSubmit: boolean = false;
  mode: 'create' | 'edit' | undefined;
  updatedId: number | null;
  mainInstituations: Option[] = [];
  instituationsTypes: Option[] = [];
  totalRate: number = 0;
  header: string = '';

  constructor(
    private readonly fb: FormBuilder,
    private readonly insService: InstituationService,
    private readonly messageService: AppMessageService,
    private readonly translate: TranslateService,
    private readonly parameterService: ParameterService,
    private readonly route: ActivatedRoute,
    private readonly caseService: CaseService,
    private caseStatusPipe: CaseStatusPipe,     private dateFormatPipe: DateFormatPipe
  ) {

    this.getTranslatedStatuses()
  }

    getTranslatedStatuses(): void {
    const enumValues: CaseStatusesEnum[] = [
      CaseStatusesEnum.started,
      CaseStatusesEnum.canceled,
      CaseStatusesEnum.finished,
    ];

    const translationKeys = enumValues.map((status) => `case.status.${status}`);

    this.translate.get(translationKeys).subscribe((translations) => {
      this.statuses = enumValues.map((status) => ({
        value: status,
        label: translations[`case.status.${status}`],
      }));
    });
  }

  private setupInvoiceableValidators(): void {
    const invoiceableCtrl = this.form.get('invoiceable');
    const taxOfficeCtrl = this.form.get('taxOffice');
    const taxNumberCtrl = this.form.get('taxNumber');

    const apply = (invoiceable: boolean) => {
      if (invoiceable) {
        taxOfficeCtrl?.setValidators([Validators.required]);
        taxNumberCtrl?.setValidators([Validators.required]);
      } else {
        taxOfficeCtrl?.clearValidators();
        taxNumberCtrl?.clearValidators();

      }

      taxOfficeCtrl?.updateValueAndValidity({ emitEvent: false });
      taxNumberCtrl?.updateValueAndValidity({ emitEvent: false });
    };

    apply(!!invoiceableCtrl?.value);

    invoiceableCtrl?.valueChanges.subscribe((val) => apply(!!val));
  }

  ngOnInit() {
    this.parameterService
      .getParameterValues('data-group', 'phone-types')
      .subscribe((res) => {
        this.phoneTypes = res?.datas?.values.map((data: any) => {
          return {
            label: data.valueObject.name.value,
            value: data.valueObject.id.value,
          };
        });
      });

    this.insService.getAll().subscribe((res: any) => {
      this.mainInstituations = res.map((data: any) => {
        return { label: data?.signboard, value: Number(data.id) };
      });
    });

    this.parameterService
      .getParameterValues('data-group', 'instituationTypes')
      .subscribe((response) => {
        this.instituationsTypes = response.datas.values.map((data: any) => {
          return { label: data.valueObject.name.value, value: data.id };
        });
      });
    this.parameterService
      .getParameterValues('data-group', 'caseTypes')
      .subscribe((response) => {
        this.caseTypes = response.datas.values.map((data: any) => {
          return { label: data.valueObject.name.value, value: data.id };
        });
      });

    this.form = this.fb.group({
      instituationShortCode: new FormControl(''),
      title: new FormControl('', [Validators.required]),
      mainInstituationId: new FormControl(null),
      signboard: new FormControl('', [Validators.required]),
      taxOffice: new FormControl('',),
      taxNumber: new FormControl('',),
      contacts: [
        [
          // {
          //   name: '',
          //   prefixValue: '+90',
          //   phone: '',
          //   email: '',
          //   priority: false,
          //   type: '',
          //   description: ''
          // },
        ],
        Validators.required,
      ],
      termDay: new FormControl(''),
      labmedUsername: new FormControl(''),
      labmedInstituationCode: new FormControl(''),
      labmedUserPassword: new FormControl(''),
      isActive: new FormControl(true, [Validators.required]),
      instituationType: new FormControl(null, [Validators.required]),
      erpCode: new FormControl(''),
      note: new FormControl(''),
      isMotherChildInstituation: new FormControl(true, [Validators.required]),
      address: [null, Validators.required],
      provisionable: [false],
      invoiceable:[false],
      isFieldSales:[false],
    });

    this.setupInvoiceableValidators();
  }

  initilize(data?: any) {
    this.updatedId = null;
    this.selectedTab='instituation';
    if (data) {
       this.header = data?.id ? ` | ${data?.id} - ${data?.title}` : '';
      this.mode = 'edit';
      this.updatedId = data?.id;
      this.form.patchValue({
        ...data,
        instituationType: data?.instituationType?.id || data?.instituationType,
      });
      
      this.setupInvoiceableValidators(); 

      if (this.contactComponent && data?.contacts) {
        this.contactComponent.contactItems = data.contacts;
      }

      if (this.addressComponent && data?.address) {
        this.addressComponent.addressForm.patchValue({
          city: data.address?.city,
          formattedAddress: data?.address?.formattedAddress,
          street: data?.address?.street,
          district: data?.address?.street,
          postalCode: data?.address?.postalCode,
          addressDescription: data?.address?.addressDescription,
          latitude: data?.address?.latitude,
          longitude: data?.address?.longitude,
        });
      }
      this.getCaseList({ first: 0, rows: this.rows });
    } else {
      this.mode = 'create';
      this.form.patchValue({ ...this.initialForm });
      this.header = '';
    }
    this.openOffCanvas();
  }

  openOffCanvas() {
    this.canvas.openPopup();
  }

  onOffCanvasClosed() {
    this.form.reset();
    this.route.queryParams.subscribe((params) => {
      if (params['openSidebar'] === 'true') {
        window.close();
      }
    });
    this.caseList = [];
    this.caseListExcel = [];
    this.first = 0;
    this.rows = 10;
    this.totalCaseRecords = 0;
    this.contactComponent.reset();
    this.totalRate = 0;
    this.mode = undefined;
    this.isSubmit = false;
    this.updatedId = null;
    this.header = '';

    this.caseFilter = {
      startDate: null,
      endDate: null,
      caseType: null,
      caseStatus: null,
      callInstitution: true,
      pickupInstitution: true,
      dropoffInstitution: true,
    };
    this.selectedTab = 'instituation';
  }

  closeCanvas() {
    this.canvas.closePopup();
  }

  openAddressModal() {
    this.addressComponent.openDialog(this.form.value.address);
  }

  handleSetAddress(address: any) {
    this.form.patchValue({
      address: {
        ...address,
        latitude: Number(address?.latitude),
        longitude: Number(address?.longitude),
      },
    });
  }

  save() {
    this.isSubmit = true;

    // Mark all controls as touched to show validation errors
    this.form.markAllAsTouched();

    if (this.form.invalid) return;

    this.insService
      .create({
        ...this.form.value,
        address: {
          ...this.form.value?.address,
          latitude: Number(this.form.value?.address?.latitude),
          longitude: Number(this.form.value?.address?.longitude),
        },
      })
      .subscribe((res) => {
        this.messageService.successToast(
          this.translate.instant('common.success'),
          this.translate.instant('common.saveSuccessToastMessage')
        );
        this.saveOn.emit(res);
        this.canvas.closePopup();
      });
  }

  update() {
    this.isSubmit = true;

    // Mark all controls as touched to show validation errors
    this.form.markAllAsTouched();

    if (this.form.invalid) return;
    this.insService
      .update({
        id: this.updatedId,
        ...this.form.value,
        address: {
          ...this.form.value?.address,
          latitude: Number(this.form.value?.address?.latitude),
          longitude: Number(this.form.value?.address?.longitude),
        },
      })
      .subscribe((res) => {
        this.messageService.infoToast(
          this.translate.instant('common.success'),
          this.translate.instant('common.updateSuccessToastMessage')
        );
        this.updateOn.emit(res);
        this.canvas.closePopup();
      });
  }

  onInput(event: any): void {
    event.target.value = event.target.value.replaceAll(/\d/g, '');
  }

  updateContacts(updatedContacts: any[]) {
    this.form.patchValue({
      contacts: updatedContacts,
    });
  }

  clearCaseFilter() {
    this.caseFilter = {
      startDate: null,
      endDate: null,
      caseType: null,
      caseStatus: null,
      callInstitution: true,
      pickupInstitution: true,
      dropoffInstitution: true,
    };
    this.getCaseList({
      first: 0,
      rows: this.rows,
    });
  }

  getCaseList(event: any) {
    this.first = event?.first ?? 0;
    this.rows = event?.rows ?? 10;
    const sortField = event?.sortField || 'id';
    let sortOrder = 'ASC';

    if (event?.sortOrder === -1) {
      sortOrder = 'DESC';
    }
    let page = 0;
    if (this.first != null && this.rows) {
      page = Math.floor(this.first / this.rows);
    }

    if (this.updatedId) {
      this.caseService
        .getCaseListByIntituationId(this.updatedId, {
          ...this.caseFilter,
          rows: this.rows,
          first: page,
          sortField,
          sortOrder,
        })
        .subscribe((res: any) => {
          this.caseList = res?.items ?? [];
          this.caseListExcel = res?.analize ?? []; 
          this.totalCaseRecords = res.total;
        });
    } else {
      this.caseList = [];
      this.caseListExcel = [];
      this.totalCaseRecords = 0;
    }
  }

  setTab(tab: 'instituation' | 'case') {
    this.selectedTab = tab;
    setTimeout(() => {
     
    }, 100);
  }

  get phones(): any[] {
    return (
      this.form
        ?.get('contacts')
        ?.value?.filter((contact: any) => contact.phone) || []
    );
  }

  updatePhoneItems(updatedPhones: any[]): void {
    const allContacts = this.form?.get('contacts')?.value || [];
    const nonPhoneContacts = allContacts.filter(
      (contact: any) => !contact.phone
    );

    const updatedPhoneContacts = updatedPhones.map((phone) => ({
      ...phone,
    }));

    this.form.patchValue({
      contacts: [...nonPhoneContacts, ...updatedPhoneContacts],
    });
  }

  exportToExcel(): void {
    if (!this.caseListExcel || !this.caseListExcel.length) {
      return;
    }

    const excelData = this.caseListExcel.map((item: any) => ({
      ID: item?.id ?? '',
      'Protokol No': item?.caseNo ?? '',
      'Vaka Tarihi': this.dateFormatPipe.transform(
        item?.caseDate,
        true
      ),
      'Vaka Tipi': item?.caseType?.valueObject?.name?.value ?? '',
      'Vaka Durumu': this.caseStatusPipe.transform(item?.caseStatus),
      'Ad Soyad':
        (item?.patientInformations?.firstName ?? '') +
        ' ' +
        (item?.patientInformations?.lastName ?? ''),
      'Alındığı Kurum':
        item?.addressInformations?.pickupInstitution?.signboard ?? '',
      'Bırakıldığı Kurum':
        item?.addressInformations?.dropoffInstitution?.signboard ?? '',
      'Çağrı Kurum':
        item?.caseInformations?.institution?.signboard ?? '',
    }));

    const worksheet: XLSX.WorkSheet =
      XLSX.utils.json_to_sheet(excelData);

    worksheet['!cols'] = [
      { wch: 8 },   // ID
      { wch: 18 },  // Protokol No
      { wch: 14 },  // Vaka Tarihi
      { wch: 22 },  // Vaka Tipi
      { wch: 16 },  // Vaka Durumu
      { wch: 24 },  // Ad Soyad
      { wch: 38 },  // Alındığı Kurum
      { wch: 38 },  // Bırakıldığı Kurum
      { wch: 38 },  // Çağrı Kurum
    ];
    const workbook: XLSX.WorkBook = {
      Sheets: { Vakalar: worksheet },
      SheetNames: ['Vakalar'],
    };

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    this.saveExcelFile(excelBuffer, 'case-list');
  }


  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });

    saveAs(data, `${fileName}_${new Date().getTime()}.xlsx`);
  }
}
